<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text="">
          </back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content" class="ion-padding">
      <ion-grid fixed>
        <!-- <div
          class="c-header -contain u-bg-yellow"
          :style="{
            'background-image':
              'url(' + require('@arag/assets/img/slider/arag.svg') + ')',
          }"
        >
          <img
            class="c-header__logo"
            width="40"
            src="@/assets/img/arag_logo.png"
          />
        </div> -->
        <Header
          class="u-bg-yellow -contain"
          headline="Sie suchen persönliche Unterstützung rund um ein Gesundheitsthema?"
          :image="require('@arag/assets/img/slider/arag.svg')"
          :logo="require('@/assets/img/arag_logo.png')"
          logoWidth="40"
          hideButton />
        <p class="ion-padding-top ion-hide-lg-up">
          <b
            >Sie suchen persönliche Unterstützung rund um ein
            Gesundheitsthema?</b
          >
        </p>
        <p>
          Die ARAG Gesundheitsassistenten nehmen sich individuell Ihrem Anliegen
          an und unterstützen Sie bei verschiedenen Gesundheitsthemen:
        </p>
        <ul>
          <li>Zahngesundheit</li>
          <li>Mentale Gesundheit</li>
          <li>Körperliche Gesundheit</li>
          <li>Reha</li>
        </ul>
        u.v.m.
        <p>
          Vor einer anstehenden Behandlung können Sie anhand des
          Behandlungsplans auch prüfen lassen, ob Sie Ihren Eigenanteil senken
          können.
        </p>
        <p class="ion-padding-bottom">
          Ziel ist es, Sie von Ihren Beschwerden zu befreien und langwierigen
          Behandlungen ein Ende zu setzen.
        </p>
        <!-- <div class="c-card ion-text-center -yellow">
          <ion-row class="ion-align-items-center">
            <ion-col>
              <img src="@/assets/img/content/roodiecheck_schmerzen.svg" />
            </ion-col>
            <ion-col>
              <img
                src="@/assets/img/content/roodiecheck_mentale_gesundheit.svg"
              />
            </ion-col>
            <ion-col>
              <img
                src="@/assets/img/content/roodiecheck_schwere_zahnbehandlung.svg"
              />
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <div>Körperliche Beschwerden</div>
            </ion-col>
            <ion-col>
              <div>Mentale Gesundheit</div>
            </ion-col>
            <ion-col>
              <div>Schwere Zahnbehandlung</div>
            </ion-col>
          </ion-row>
        </div> -->
        <!-- <div class="c-line"></div> -->
        <ion-slides
          class="c-nugget-slider -span ion-margin-top"
          :options="linkSlideOpts"
          ref="linkSlider"
          @ionSlidesDidLoad="$refs.linkSlider?.$el.update()">
          <ion-slide>
            <div
              class="c-nugget"
              @click="
                $router.push({
                  name: 'arag-mental',
                })
              ">
              <div
                class="c-nugget__image u-bg-yellow"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/header/icon_mental.svg') +
                    ')',
                }"></div>
              <div class="c-nugget__label">Mentale<br />Gesundheit</div>
            </div>
          </ion-slide>
          <ion-slide>
            <div
              class="c-nugget"
              @click="
                $router.push({
                  name: 'arag-zahn',
                })
              ">
              <div
                class="c-nugget__image u-bg-orange"
                :style="{
                  'background-image':
                    'url(' + require('@/assets/img/slider/arag_zahn.svg') + ')',
                }"></div>
              <div class="c-nugget__label">Zahn-<br />gesundheit</div>
            </div>
          </ion-slide>
          <ion-slide>
            <div
              class="c-nugget"
              @click="
                $router.push({
                  name: 'arag-koerperlich',
                })
              ">
              <div
                class="c-nugget__image u-bg-green"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/home/icon_coaching_herz_iso.svg') +
                    ')',
                }"></div>
              <div class="c-nugget__label">Körperliche<br />Gesundheit</div>
            </div>
          </ion-slide>
        </ion-slides>
        <!-- <ion-row class="ion-margin-top">
          <ion-col size="6">
            <div
              class="c-nugget"
              @click="
                $router.push({
                  name: 'arag-mental',
                })
              "
            >
              <div
                class="c-nugget__image u-bg-yellow"
                :style="{
                  'background-image':
                    'url(' +
                    require('@/assets/img/header/icon_mental.svg') +
                    ')',
                }"
              ></div>
              <div class="c-nugget__label">
                Mentale Gesundheit
              </div>
            </div>
          </ion-col>
          <ion-col size="6">
            <div
              class="c-nugget"
              @click="
                $router.push({
                  name: 'arag-zahn',
                })
              "
            >
              <div
                class="c-nugget__image u-bg-orange"
                :style="{
                  'background-image':
                    'url(' + require('@/assets/img/slider/arag_zahn.svg') + ')',
                }"
              ></div>
              <div class="c-nugget__label">
                Zahngesundheit
              </div>
            </div>
          </ion-col>
        </ion-row> -->
        <ion-row class="ion-margin-top ion-text-center">
          <ion-col>
            <a
              href="#"
              @click.prevent="$router.push({ name: 'arag-anleitung' })"
              >So funktioniert's</a
            >
          </ion-col>
          <ion-col>
            <a href="#" @click.prevent="openKostenerstattungModal"
              >Kostenrückerstattung</a
            >
          </ion-col>
        </ion-row>
        <!-- <div class="ion-margin-vertical">
          <img width="50" src="@/assets/img/arag_logo.png" />
        </div> -->
        <div class="c-cta">
          <ion-row class="ion-align-items-center ion-margin-top">
            <ion-col>
              <ion-button @click="openFormContact" class="-lg-large"
                >Jetzt Kontakt aufnehmen&nbsp;
                <ion-icon :icon="mail" slot="end"></ion-icon
              ></ion-button>
            </ion-col>
            <ion-col>
              <ion-button
                class="-lg-large"
                @click="
                  $router.push({
                    name: 'home',
                    params: {
                      shouldShowPaintype: true,
                      from: 'arag',
                    },
                  })
                "
                >Roodie.Check starten&nbsp;
                <ion-icon
                  :src="require('@lib/assets/icons/roodie-white.svg')"
                  slot="end"></ion-icon
              ></ion-button>
            </ion-col>
            <!-- <ion-col class="ion-text-right">
            <img width="50" src="@/assets/img/arag_logo.png" />
          </ion-col> -->
          </ion-row>
        </div>
        <!-- <ion-row class="ion-margin-top">
          <ion-col size="auto">
            <ion-icon :src="require('@lib/assets/icons/info.svg')" />
          </ion-col>
          <ion-col>
            <ion-text color="primary">
              Das Angebot von Selfapy, therapeutenverbund.de, und MindDoc ist
              eine Zusatzleistung des jeweiligen Kooperationspartners. Sie kann
              jederzeit entfallen, wenn die Kooperation endet.
            </ion-text>
          </ion-col>
        </ion-row> -->
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import { chevronBack, mail } from "ionicons/icons";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButton,
  IonIcon,
  IonButtons,
  IonGrid,
  IonRow,
  IonCol,
  modalController,
  IonSlides,
  IonSlide,
  IonBackButton,
} from "@ionic/vue";
import FormContact from "@/components/FormContact";
import KostenerstattungModal from "@arag/components/KostenerstattungAragModal";
import Header from "@/components/Header";

export default {
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButton,
    IonIcon,
    IonButtons,
    IonGrid,
    IonRow,
    IonCol,
    Header,
    IonSlides,
    IonSlide,
    IonBackButton,
  },
  data() {
    return {
      linkSlideOpts: {
        initialSlide: 0,
        breakpoints: {
          0: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 4.2,
            spaceBetween: 20,
          },
        },
      },
    };
  },
  methods: {
    async openFormContact() {
      const modal = await modalController.create({
        component: FormContact,
        componentProps: {
          routing: "ARAG Case Management",
          reference: "Kontakt aufnehmen",
        },
      });
      return modal.present();
    },
    async openKostenerstattungModal() {
      const modal = await modalController.create({
        component: KostenerstattungModal,
      });
      return modal.present();
    },
  },
  setup() {
    return {
      chevronBack,
      mail,
    };
  },
};
</script>

<style lang="scss" scoped></style>
